import protoRoot from "../proto-root";

export default function createMessage(payload) {
  const Message = protoRoot.lookupType("comm.Message");
  const message = Message.create(payload);
  return message;
}
